<template>
  <b-container fluid>
    <page-title icon="fas fa-user-tie">
      <translate>Edit Company</translate>
    </page-title>
    <company-form :companyId="$route.params.id" />
  </b-container>
</template>
<script>
import CompanyForm from '@/components/CompanyForm'

export default {
  name: 'RegisterPage',
  title() {
    return this.$gettext('Edit Company')
  },
  components: {
    CompanyForm
  }
}
</script>
